import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getClassList } from 'helpers/backend_helper';

interface Class {
  classId: number;
  className: string;
}

interface ClassState {
  // State
  classes: Class[];
  selectedClass: Class | null;
  isLoading: boolean;
  error: string | null;
  
  // Actions
  fetchClasses: () => Promise<void>;
  setSelectedClass: (classItem: Class | null) => void;
  setClasses: (classes: Class[]) => void;
  clearError: () => void;
  reset: () => void;
}

const initialState = {
  classes: [],
  selectedClass: null,
  isLoading: false,
  error: null,
};

export const useClassStore = create<ClassState>()(
  persist(
    (set, get) => ({
      ...initialState,

      // Actions
      fetchClasses: async () => {
        set({ isLoading: true, error: null });
        
        try {
          const response = await getClassList();
          
          if (response.data && Array.isArray(response.data)) {
            const classes = response.data.map((classItem: any) => ({
              classId: classItem.classId,
              className: classItem.className,
            }));
            
            set({ classes, isLoading: false });
            // Only auto-select if no class is currently selected
            if (get().selectedClass === null) {
              set({ selectedClass: classes[0] });
            }
          } else {
            set({ classes: [], isLoading: false });
          }
        } catch (error) {
          console.error('Error fetching classes:', error);
          set({ 
            error: 'Failed to fetch classes', 
            isLoading: false 
          });
        }
      },

      setSelectedClass: (selectedClass) => set({ selectedClass }),

      setClasses: (classes) => set({ classes }),

      clearError: () => set({ error: null }),

      reset: () => set(initialState),
    }),
    {
      name: 'class-storage',
      partialize: (state) => ({
        classes: state.classes,
        selectedClass: state.selectedClass,
      }),
    }
  )
);
